import appModuleRegistry from "components/appModules/appModuleRegistry";
import { S6Request } from "components/request/request";
import { NotificationBadgeElement } from "../notificationBadge/notificationBadge";
import { NotificationBadgeData } from "../notificationBadge/notificationBadge";

const template = document.createElement("template");
template.innerHTML = `
<notification-badge></notification-badge>
`;
export class NotificationPollerElement extends HTMLElement {
  private _shadowRoot: ShadowRoot;
  private cron;
  private ongoing: boolean;
  constructor() {
    super();
    this._shadowRoot = this.attachShadow({ mode: "open" });
    this._shadowRoot.appendChild(template.content.cloneNode(true));
  }

  private connectedCallback() {
    setTimeout(() => {
      this.refreshData();
      this.cron = setInterval(
        this.refreshData,
        30000,
      );
    },
      1500);
  }

  private refreshData = () => {
    let url = this.getAttribute("url");
    if (url != null && !this.ongoing) {
      this.ongoing = true;
      url = appModuleRegistry.prefixUrl(url);
      if (this.isLDS() && !url.startsWith("pages/lds/")) {
        // Disable the real one for te LDS.
        this.ongoing = false;
        return;
      }
      S6Request.url(url).reauthenticate().get().res((d) => {
        this.data = d;
        this.ongoing = false;
      });
    }
  }

  private isLDS() {
    return window.location.href.includes("#!/lds/");
  }

  private disconnectedCallback() {
    clearInterval(this.cron);
  }

  public set data(data: NotificationBadgeData) {
    let badge = (this._shadowRoot.querySelector("notification-badge") as NotificationBadgeElement);
    badge.data = data;
  }
}

export function initNotificationBadgePollerWebComponent() {
  window.customElements.define("notification-poller", NotificationPollerElement);
}
